<template>
  <b-container class="login-page py-5">
    <b-row class="justify-content-center">
      <b-col md="6" lg="5">
        <b-card title="Iniciar Sesión" class="shadow">
          <b-form @submit.prevent="handleLogin">
            <b-form-group label="Email" label-for="email">
              <b-form-input
                id="email"
                v-model="form.email"
                type="email"
                required
                placeholder="tu@email.com">
              </b-form-input>
            </b-form-group>
            
            <b-form-group label="Contraseña" label-for="password">
              <b-form-input
                id="password"
                v-model="form.password"
                type="password"
                required
                placeholder="Tu contraseña">
              </b-form-input>
            </b-form-group>
            
            <b-form-checkbox v-model="form.remember" class="mb-3">
              Recordarme
            </b-form-checkbox>
            
            <b-button 
              type="submit" 
              variant="primary" 
              block
              :disabled="loading">
              <b-spinner v-if="loading" small class="mr-2"></b-spinner>
              Iniciar Sesión
            </b-button>
          </b-form>
          
          <hr>
          
          <div class="text-center">
            <p>¿No tienes una cuenta?</p>
            <b-button variant="outline-primary" :to="{ name: 'Register' }">
              Registrarse
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'LoginPage',
  data() {
    return {
      form: {
        email: '',
        password: '',
        remember: false
      },
      loading: false
    }
  },
  methods: {
    async handleLogin() {
      this.loading = true
      
      const result = await this.$store.dispatch('login', this.form)
      
      if (result.success) {
        this.$bvToast.toast('Bienvenido', {
          title: 'Inicio de sesión exitoso',
          variant: 'success',
          solid: true
        })
        
        // Redirigir a la página anterior o al home
        const redirect = this.$route.query.redirect || '/'
        this.$router.push(redirect)
      } else {
        this.$bvToast.toast(result.message || 'Error al iniciar sesión', {
          title: 'Error',
          variant: 'danger',
          solid: true
        })
      }
      
      this.loading = false
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: 60vh;
}
</style>